// No zod here: utils/tools.js imports this, so a zod enum put all of zod
// (~60 KB) on every page to check one string.
const ENVS = ["development", "production", "preview", "test"] as const;

const parseEnv = (value: string | undefined): (typeof ENVS)[number] => {
  if (!ENVS.includes(value as (typeof ENVS)[number])) {
    throw new Error(
      `Invalid environment ${JSON.stringify(value)}: expected one of ${ENVS.join(", ")}`,
    );
  }
  return value as (typeof ENVS)[number];
};

export const ENV = parseEnv(
  process.env.NEXT_PUBLIC_VERCEL_ENV ||
    process.env.VERCEL_ENV ||
    process.env.NODE_ENV,
);

export const isProduction = ENV === "production";
